module.exports = "<svg id=\"837803d5-8357-4956-92a5-bf787bdefdc3\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.5 50\"><title>RightArrow</title><path d=\"M13.57,45.73,34.3,25,13.57,4.27A2.5,2.5,0,0,1,17.1.73l22.5,22.5a2.5,2.5,0,0,1,0,3.54L17.1,49.27a2.5,2.5,0,1,1-3.54-3.54Z\" transform=\"translate(-12.83 0)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/RightArrow.svg
// module id = 521
// module chunks = 1